<template>
  <v-card>
    <v-toolbar dark color="primary">
      <v-toolbar-title>Attendance Records</v-toolbar-title>
      <v-spacer></v-spacer>
    </v-toolbar>
    <v-container fluid>
      <v-data-table
        :headers="attendanceHeaders"
        :items="attendanceRecords"
        :items-per-page="20"
        :search="attendanceSearch"
        class="elevation-1"
      >
      </v-data-table>
    </v-container>
  </v-card>
</template>
<script>
export default {
  components: {},
  data: () => ({
    attendanceHeaders: [
      { text: "Date", value: "date" },
      { text: "Result", value: "result" },
    ],
    attendanceRecords: [],
  }),
  computed: {},
  methods: {},
  mounted() {
    this.$sisApi("get", "my-schedule/attendance")
      .then((response) => {
        this.attendanceRecords = response.data;
      })
      .catch((error) => {
        console.log(error);
      });
  },
};
</script>
